// extracted by mini-css-extract-plugin
export default {"image":"ImageOnly_image__HQTXl"};